import { render } from "./OrderRatio.vue?vue&type=template&id=375d9bbb&scoped=true"
import script from "./OrderRatio.vue?vue&type=script&lang=js"
export * from "./OrderRatio.vue?vue&type=script&lang=js"

import "./OrderRatio.vue?vue&type=style&index=0&id=375d9bbb&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-375d9bbb"]])

export default __exports__